import { useRef, useState } from "react";
import { ImageIcon, Loader2, Trash2, Upload } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { adminApi, errMsg, imgUrl } from "@/lib/api";
import { refreshBrand } from "@/lib/brand";

export function LogoField({ version, onChange }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const url = version ? imgUrl(`/api/platform/logo?v=${version}`) : "";
  const run = async (call, ok) => {
    setBusy(true);
    try {
      const { data } = await call();
      onChange(data.logo_version || "");
      refreshBrand();
      toast.success(ok);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const pick = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) { toast.error("A logo deve ter no máximo 2 MB"); return; }
    const fd = new FormData();
    fd.append("file", file);
    run(() => adminApi.post("/logo", fd), "Logo do sistema atualizada");
  };
  return (
    <div className="sm:col-span-2 flex flex-wrap items-center gap-4 rounded-lg border p-4" data-testid="system-logo-field">
      <div className="grid h-16 min-w-[4rem] max-w-[12rem] place-items-center rounded-xl border bg-muted/40 px-2">
        {url ? <img src={url} alt="Logo do sistema" className="h-12 w-auto max-w-[11rem] object-contain" data-testid="system-logo-preview" /> : <ImageIcon className="h-6 w-6 text-muted-foreground" />}
      </div>
      <div className="min-w-[12rem] flex-1">
        <p className="font-semibold">Logo do sistema</p>
        <p className="text-xs text-muted-foreground">Aparece na página inicial, nas telas de login e cadastro e na aba do navegador. PNG, JPG, WEBP, SVG ou ICO até 2 MB. Prefira imagem quadrada com fundo transparente.</p>
      </div>
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml,image/x-icon,.ico" className="hidden" onChange={pick} data-testid="system-logo-input" />
      <div className="flex gap-2">
        <Button type="button" variant="outline" disabled={busy} onClick={() => ref.current?.click()} data-testid="system-logo-upload-btn">
          {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Upload className="h-4 w-4 mr-2" />}{url ? "Trocar logo" : "Enviar logo"}
        </Button>
        {url && <Button type="button" variant="ghost" disabled={busy} onClick={() => run(() => adminApi.delete("/logo"), "Logo removida")} data-testid="system-logo-remove-btn"><Trash2 className="h-4 w-4 mr-2" />Remover</Button>}
      </div>
    </div>
  );
}
